import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import "./App.scss";
import * as s from "./App.styles";

import { useSelector } from "react-redux";

// images
import logo from "./assets/images/logo.png";

// Components
import Sidebar from "./components/shared/sidebar/Sidebar";
import MainView from "./container/MainView";

const App = () => {
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.auth.role);
  // state
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);

  const menuItemsClient = [
    { name: "Dashboard", to: "/", icon: "fab fa-dashcube", subMenuItems: [] },
    // {
    //   name: "My Projects",
    //   to: "/projects",
    //   icon: "fas fa-clipboard-list",
    //   subMenuItems: [],
    // },
    {
      name: "My Documents",
      to: "/documents",
      icon: "fas fa-hourglass-end",
      subMenuItems: [],
    },
    {
      name: "My Profile",
      to: "/profile",
      icon: "fas fa-user-circle",
      subMenuItems: [],
    },
    {
      name: "Logout",
      to: "/Logout",
      icon: "fas fa-sign-out-alt",
      subMenuItems: [],
    },
  ];

  const menuItemsAdmin = [
    { name: "Dashboard", to: "/", icon: "fab fa-dashcube", subMenuItems: [] },
    {
      name: "Clients",
      to: "/clients",
      icon: "fas fa-clipboard-list",
      subMenuItems: [],
    },
    {
      name: "Time Tracker",
      to: "/time-tracker",
      icon: "fas fa-hourglass-end",
      subMenuItems: [],
    },
    {
      name: "Managers",
      to: "/managers",
      icon: "fas fa-users",
      subMenuItems: [],
    },
    {
      name: "My Profile",
      to: "/profile",
      icon: "fas fa-user-circle",
      subMenuItems: [],
    },
    {
      name: "Logout",
      to: "/Logout",
      icon: "fas fa-sign-out-alt",
      subMenuItems: [],
    },
  ];

  const onRouteChanged = useCallback(() => {
    const fullPageLayoutRoutes = [
      "/login",
      "/create-client",
      "/create-manager",
      "/404",
      "/client-profile",
      "/task-profile",
      "/folder-profile"
    ];
    for (let i = 0; i < fullPageLayoutRoutes.length; i++) {
      if (location.pathname === fullPageLayoutRoutes[i]) {
        setIsFullPageLayout(true);
        break;
      } else {
        setIsFullPageLayout(false);
      }
    }
  }, [location]);

  // UseEffect
  useEffect(() => {
    onRouteChanged();
  }, [location, onRouteChanged]);

  return (
    <s.App>
      {!isFullPageLayout && (
        <Sidebar
          logo={logo}
          menuItems={
            isAuthenticated === "client" ? menuItemsClient : menuItemsAdmin
          }
        />
      )}
      <MainView isFullPageLayout={isFullPageLayout} />
    </s.App>
  );
};

export default App;
